/**
 * A license change scheduled for the end of the current billing period.
 * licensePlanId = null removes the license on the effective date.
 */
export class AgentLicensePlanChange {
	public id: number;
	public agentLicensePlanId: number;
	public licensePlanId: number;
	public quantity: number;
	public effectiveDate: string;

	constructor(agentLicensePlanChange: AgentLicensePlanChange) {
		Object.assign(this, agentLicensePlanChange);
	}
}
